import { createApp, reactive, ref } from 'vue';
import VueCookies from 'vue-cookies'
import axios from './api/http';
import App from './App';
import router from './router';
import api from './api/api';
import directive from './directive'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import * as Icons from '@ant-design/icons-vue';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { i18n } from './utils/i18nUtils';
import {filterOption, getCurrentUser} from './utils/common';

NProgress.configure({ showSpinner: false })

const app = createApp(App);
//全局变量
app.config.globalProperties.$language =(localStorage.getItem('userInfo') == "undefined" || JSON.parse(localStorage.getItem('userInfo')) ==null) ? "en-US" : JSON.parse(localStorage.getItem('userInfo')).language;
app.config.globalProperties.$userType = (localStorage.getItem('userInfo') == "undefined" || JSON.parse(localStorage.getItem('userInfo')) ==null) ? "" : JSON.parse(localStorage.getItem('userInfo')).type;
app.config.globalProperties.$distributorId =(localStorage.getItem('userInfo') == "undefined"  || JSON.parse(localStorage.getItem('userInfo')) ==null) ? "" : JSON.parse(localStorage.getItem('userInfo')).distributorId;
app.config.globalProperties.$pageIndex =1;
app.config.globalProperties.$pageSize = 20;
app.config.globalProperties.$pageSizeOptions = ['20', '50', '100'];
app.config.globalProperties.$filterOption = filterOption;
app.config.globalProperties.$getCurrentUser = getCurrentUser();
app.config.globalProperties.$i18n = i18n;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$api = api;
app.config.globalProperties.$message = Antd.message;
app.config.globalProperties.$baseUrl = axios.defaults.baseURL;
app.config.globalProperties.$imageUrl = axios.defaults.baseURL+'/static/';

router.beforeEach((to, from, next) => {
    NProgress.start();
    let token = $cookies.get('token')
    if (to.path == "/" || to.path == "/general/docs/index" || to.path == "/general/docs/matchMap") {

        if(to.path == "/" ){
            $cookies.remove('token');
        }

        next();
    } else {
        if (!token) {
            next({ path: '/' });
        } else {
            if (to.query.title) {
                document.title = to.query.title;
            }
            next();
        }
    }
    NProgress.done()
});

router.afterEach(() => {
    NProgress.done()
  })



//全局注册
Object.keys(Icons).forEach((key)=>{
    app.component(key, Icons[key]);
})
app.component('QuillEditor',QuillEditor );


app.use(Antd)
    .use(VueCookies)
    .use(router)
    .use(directive)
    .mount('#app');